wbApp.controller('LogUploadContactCtrl', ['$scope', '$modal', 'rfidCardsSvc',
function ($scope, $modal, rfidCardsSvc) {

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.fromDate = moment().startOf('month').toDate();
    $scope.toDate = moment().endOf('month').toDate();


    $scope.gridOptions = {
        sortInfo: { fields: ['createdAt'], directions: ['dsc'] },
        columnDefs: [{ field: 'deviceSerialNumber', displayName: "TXT_LBL_DEVICE_SERIAL_NUMBER" },
                     { field: 'noOfLogEntriesUploaded', displayName: "TXT_LBL_NO_OF_LOG_ENTRIES_UPLOADED", align: 'right', width: '150px' },
                     { field: 'noOfNewLogEntries', displayName: "TXT_LBL_NO_OF_NEW_LOG_ENTRIES", sort: 'locale', align: 'right', width: '150px' },
                     { field: 'createdAt', displayName: "TXT_LBL_UPLOADED_AT", cellFilter: "date:'EEE (dd.MM.yy) HH:mm:ss'", width: '160px' },
        ],
        noCommandColumn: true
    };

    $scope.$on('refreshData', function (e, data) {
        refreshData($scope.fromDate, $scope.toDate);
    });

    function refreshData(fromDate, toDate) {
        $scope.uploadContacts = rfidCardsSvc.getAllUploadContacts(fromDate, toDate);
    }

    refreshData($scope.fromDate, $scope.toDate);

    $scope.onFromDateChange = function (fromDate) {
        if (fromDate) {
            refreshData(fromDate, $scope.toDate);
        }
    }

    $scope.onToDateChange = function (toDate) {
        if (toDate) {
            refreshData($scope.fromDate, toDate);
        }
    }
}]);
